import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthFacade } from '@vasta/client-core-authentication';

export const tenantValidGuard = (route: ActivatedRouteSnapshot) => {
  const auth = inject(AuthFacade);
  const router = inject(Router);
  const tenantId = route.params['tenantId'];

  return auth.whenUserSettled$.pipe(
    map(() => {
      const tenants = auth.tenants();
      const match = tenants.find((t) => t.externalId === tenantId);
      if (match) return true;

      const first = tenants[0];
      return first
        ? router.createUrlTree([first.externalId, 'scheduling', 'schedule'])
        : router.createUrlTree(['tenants', 'new']);
    }),
  );
};
